import { render, staticRenderFns } from "./glaszetten.vue?vue&type=template&id=15f706c1&scoped=true"
import script from "./glaszetten.vue?vue&type=script&lang=js"
export * from "./glaszetten.vue?vue&type=script&lang=js"
import style0 from "./glaszetten.vue?vue&type=style&index=0&id=15f706c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f706c1",
  null
  
)

export default component.exports